import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-orange-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_0417eede-7f78-4297-8d8e-61eaa65cf77a/artifacts/912rynrx_SIX_0781F903-DCAC-4428-8B33-C4C3EA246FFA.png" 
              alt="SubZero Coolers" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm mb-4">
              Premium commercial refrigeration solutions trusted by businesses nationwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Installation</li>
              <li className="text-gray-400 text-sm">Maintenance & Repair</li>
              <li className="text-gray-400 text-sm">Custom Design</li>
              <li className="text-gray-400 text-sm">Professional Service</li>
              <li className="text-gray-400 text-sm">Preventive Maintenance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">
                <p className="text-xs text-gray-500 mb-1">Executive Administrator</p>
                <p className="font-medium text-gray-300">Devon Granda</p>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0 text-orange-500" />
                <div>
                  <p className="text-xs text-gray-500">Office</p>
                  <a href="tel:772-362-9384" className="hover:text-orange-500 transition-colors">
                    772-362-9384
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0 text-orange-500" />
                <div>
                  <p className="text-xs text-gray-500">Owner/Manager (Luis Granda)</p>
                  <a href="tel:772-353-7263" className="hover:text-orange-500 transition-colors font-semibold">
                    772-353-7263
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0 text-orange-500" />
                <a href="mailto:devon.granda@subzerocoolers.net" className="hover:text-orange-500 transition-colors">
                  devon.granda@subzerocoolers.net
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-orange-500" />
                <span>Serving Commercial Clients Across Florida</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            © {currentYear} Sub-Zero Coolers, LLC. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
